import { useAtomValue } from 'jotai';
import { persistedOverviewAtom } from '../atoms';
import { NETWORK_METRICS } from '../NetworkPanel/hooks/useNetworkMetricsData';

/**
 * Hook to access network metrics order from atoms.
 * Falls back to the default NETWORK_METRICS order when no persisted order exists.
 */
function useNetworkOverview() {
  const { networkMetrics } = useAtomValue(persistedOverviewAtom);

  const orderedMetricIds =
    networkMetrics && Object.keys(networkMetrics).length > 0
      ? Object.entries(networkMetrics)
          .sort(([, a], [, b]) => a.order - b.order)
          .map(([id]) => id)
          .filter((id) => NETWORK_METRICS.includes(id))
      : [...NETWORK_METRICS];

  return {
    networkMetrics: orderedMetricIds,
    networkMetricsData: networkMetrics || {},
  };
}

export default useNetworkOverview;
